export enum RoundRobinAllocateType {
  AllocateEqually = 1,
  AllocateWeighting = 2,
}
